import script from "./contribute.vue?vue&type=script&setup=true&lang=js"
export * from "./contribute.vue?vue&type=script&setup=true&lang=js"

import "./contribute.vue?vue&type=style&index=0&id=594cf4f6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594cf4f6"]])

export default __exports__